import { render } from "./Foreigners.vue?vue&type=template&id=03d4562a"
import script from "./Foreigners.vue?vue&type=script&lang=js"
export * from "./Foreigners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__